export const APP = 'Admissions-Web'
